import React from 'react'
import { useStyles } from './Styles'
import { Bean } from 'components'

const Background: React.FC = () => {
  const classes = useStyles({})
  const beans = [
    {
      angle: 45,
      size: {
        width: 615,
        height: 150
      },
      position: { top: '28%', left: '-10%' },
      opacity: 0.02,
      fill: true
    },
    {
      angle: 45,
      size: {
        width: 240,
        height: 50
      },
      position: { top: '65%', left: '-10%' },
      opacity: 0.1,
      fill: true
    },
    {
      angle: -45,
      size: {
        width: 640,
        height: 150
      },
      position: { top: '-8%', left: '20%' },
      opacity: 0.08
    },
    {
      angle: -45,
      size: {
        width: 540,
        height: 110
      },
      position: { bottom: '55%', right: '-20%' },
      opacity: 0.04,
      fill: true
    },
    {
      angle: 45,
      size: {
        width: 140,
        height: 50
      },
      position: { top: '15%', right: '45%' },
      opacity: 0.05,
      fill: true
    },
    {
      angle: 45,
      size: {
        width: 340,
        height: 90
      },
      position: { top: '5%', right: '20%' },
      opacity: 0.03,
      fill: true
    },
    {
      angle: 45,
      size: {
        width: 340,
        height: 90
      },
      position: { bottom: '-5%', right: '20%' },
      opacity: 0.03,
      fill: true
    },
    {
      angle: 45,
      size: {
        width: 240,
        height: 60
      },
      position: { bottom: '35%', right: '20%' },
      opacity: 0.1,
      fill: false
    },
    {
      angle: -45,
      size: {
        width: 340,
        height: 120
      },
      position: { bottom: '0%', left: '15%' },
      opacity: 0.1,
      fill: false
    },
    {
      angle: 45,
      size: {
        width: 340,
        height: 120
      },
      position: { top: '0%', right: '5%' },
      opacity: 0.1,
      fill: false
    }
  ]
  return (
    <div className={classes.root}>
      {beans.map((bean, i) => (
        <Bean
          key={`bean-${i}`}
          index={i}
          angle={bean.angle}
          size={bean.size}
          position={bean.position}
          opacity={bean.opacity}
          fill={bean.fill}
        />
      ))}
    </div>
  )
}

export default Background
